import { ErrorHandler } from "@angular/core";

// @ts-expect-error TS7034
let errors = [];

(window as any).logErrors = (numberOfErrors?: number) => {
	if (typeof numberOfErrors === "number") {
		// @ts-expect-error TS7005
		console.log(errors.slice(-numberOfErrors));
	} else {
		// @ts-expect-error TS7005
		console.log(errors);
	}
};

export class CommonErrorHandler implements ErrorHandler {
	handleError(err: any) {
		console.error(err);

		// Keep track of the last 50 errors
		errors.push(err);

		if (errors.length > 50) {
			// @ts-expect-error TS7005
			errors = errors.slice(-50);
		}
	}
}
